import { Brand, Program } from '..';

const VrboPrograms: Record<string, Program> = {
  // 'at-vrbo': {
  //   id: 'at-vrbo',
  //   name: 'Vrbo AT',
  //   brand: Brand.VRBO,
  //   posa: 'AT',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'de_DE',
  //     langId: 1031,
  //   },
  // },

  // 'au-vrbo': {
  //   id: 'au-vrbo',
  //   name: 'Vrbo AU',
  //   brand: Brand.VRBO,
  //   posa: 'AU',
  //   currency: 'AUD',
  //   locale: {
  //     baseName: 'en_AU',
  //     langId: 3081,
  //   },
  // },

  // 'br-vrbo': {
  //   id: 'br-vrbo',
  //   name: 'Vrbo BR',
  //   brand: Brand.VRBO,
  //   posa: 'BR',
  //   currency: 'BRL',
  //   locale: {
  //     baseName: 'pt_PR',
  //     langId: 1046,
  //   },
  // },

  'ca-vrbo': {
    id: 'ca-vrbo',
    name: 'Vrbo CA',
    brand: Brand.VRBO,
    posa: 'CA',
    currency: 'CAD',
    locale: {
      baseName: 'en_CA',
      langId: 4105,
    },
  },

  // 'dk-vrbo': {
  //   id: 'dk-vrbo',
  //   name: 'Vrbo DK',
  //   brand: Brand.VRBO,
  //   posa: 'DK',
  //   currency: 'DKK',
  //   locale: {
  //     baseName: 'da_DK',
  //     langId: 1030,
  //   },
  // },

  // 'es-vrbo': {
  //   id: 'es-vrbo',
  //   name: 'Vrbo ES',
  //   brand: Brand.VRBO,
  //   posa: 'ES',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'es_ES',
  //     langId: 3082,
  //   },
  // },

  // 'fi-vrbo': {
  //   id: 'fi-vrbo',
  //   name: 'Vrbo FI',
  //   brand: Brand.VRBO,
  //   posa: 'FI',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'fi_FI',
  //     langId: 1035,
  //   },
  // },

  // 'gr-vrbo': {
  //   id: 'gr-vrbo',
  //   name: 'Vrbo GR',
  //   brand: Brand.VRBO,
  //   posa: 'GR',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'el_GR',
  //     langId: 1032,
  //   },
  // },

  // 'it-vrbo': {
  //   id: 'it-vrbo',
  //   name: 'Vrbo IT',
  //   brand: Brand.VRBO,
  //   posa: 'IT',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'it_IT',
  //     langId: 1040,
  //   },
  // },

  // 'jp-vrbo': {
  //   id: 'jp-vrbo',
  //   name: 'Vrbo JP',
  //   brand: Brand.VRBO,
  //   posa: 'JP',
  //   currency: 'JPY',
  //   locale: {
  //     baseName: 'ja_JP',
  //     langId: 1041,
  //   },
  // },

  // 'mx-vrbo': {
  //   id: 'mx-vrbo',
  //   name: 'Vrbo MX',
  //   brand: Brand.VRBO,
  //   posa: 'MX',
  //   currency: 'MXN',
  //   locale: {
  //     baseName: 'es_MX',
  //     langId: 2058,
  //   },
  // },

  // 'nl-vrbo': {
  //   id: 'nl-vrbo',
  //   name: 'Vrbo NL',
  //   brand: Brand.VRBO,
  //   posa: 'NL',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'nl_NL',
  //     langId: 1043,
  //   },
  // },

  // 'no-vrbo': {
  //   id: 'no-vrbo',
  //   name: 'Vrbo NO',
  //   brand: Brand.VRBO,
  //   posa: 'NO',
  //   currency: 'NOK',
  //   locale: {
  //     baseName: 'nb_NO',
  //     langId: 1044,
  //   },
  // },

  // 'nz-vrbo': {
  //   id: 'nz-vrbo',
  //   name: 'Vrbo NZ',
  //   brand: Brand.VRBO,
  //   posa: 'NZ',
  //   currency: 'NZD',
  //   locale: {
  //     baseName: 'en_NZ',
  //     langId: 5129,
  //   },
  // },

  // 'pl-vrbo': {
  //   id: 'pl-vrbo',
  //   name: 'Vrbo PL',
  //   brand: Brand.VRBO,
  //   posa: 'PL',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'pl_PL',
  //     langId: 1045,
  //   },
  // },

  // 'pt-vrbo': {
  //   id: 'pt-vrbo',
  //   name: 'Vrbo PT',
  //   brand: Brand.VRBO,
  //   posa: 'PT',
  //   currency: 'EUR',
  //   locale: {
  //     baseName: 'pt_PT',
  //     langId: 2070,
  //   },
  // },

  // 'se-vrbo': {
  //   id: 'se-vrbo',
  //   name: 'Vrbo SE',
  //   brand: Brand.VRBO,
  //   posa: 'SE',
  //   currency: 'SEK',
  //   locale: {
  //     baseName: 'sv_SE',
  //     langId: 1053,
  //   },
  // },

  // 'sg-vrbo': {
  //   id: 'sg-vrbo',
  //   name: 'Vrbo SG',
  //   brand: Brand.VRBO,
  //   posa: 'SG',
  //   currency: 'SGD',
  //   locale: {
  //     baseName: 'en_SG',
  //     langId: 18441,
  //   },
  // },

  'uk-vrbo': {
    id: 'uk-vrbo',
    name: 'Vrbo UK',
    brand: Brand.VRBO,
    posa: 'UK',
    currency: 'GBP',
    locale: {
      baseName: 'en_GB',
      langId: 2057,
    },
  },

  'us-vrbo': {
    id: 'us-vrbo',
    name: 'Vrbo US',
    brand: Brand.VRBO,
    posa: 'US',
    currency: 'USD',
    locale: {
      baseName: 'en_US',
      langId: 1033,
    },
  },
};

export { VrboPrograms };
